"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); // @endindex
// @index('./*', pp => `import * as ${pp.name} from '${pp.path}';`, { "ignore": ["./*.ts", "./*.md"] })

var InputMappingItem = require("./InputMappingItem");

exports.InputMappingItem = InputMappingItem;